import MenuLessonItemList, { MenuLessonItemListProps } from './MenuLessonItemList';

export type { MenuLessonItemListProps };
export default MenuLessonItemList;
